import { ContextStore } from '../../../react-core/Flux/Variables';
import { RoutesHelper } from '../../../react-core/Utils/RoutesHelper';
import { AjaxWrapper } from '../../../react-core/Async/AjaxWrapper';
import { Promise } from '../../../react-core/Async/Promise';
import { AccountModelView } from '../../Models/Domains/Transactions/Investments/AccountModelView';

declare var IS_RUNNING_IN_APP_POOL;

export class AccountModelViewClient {
  private _culture: string;

  public constructor() {
    var contextStoreState = ContextStore.getContext();
    this._culture = contextStoreState.culture;
  }

  public get(hierarchyId: string, cashSpecific: boolean): Promise<AccountModelView, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Transaction/AccountModelView/Get';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { hierarchyId: hierarchyId, cashSpecific: cashSpecific }

    return AjaxWrapper.get<AccountModelView, any>(url, data);
  }
}

